
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ChangingAgrupationIconComponent } from "./changing-agrupation-icon.svg";

export const ChangingAgrupationIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ChangingAgrupationIconComponent {...props} />;
};
